import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header border-0 cursor-pointer bg-success px-4\"><div class=\"card-title\"><div class=\"d-flex align-items-center position-relative my-1\"><span class=\"card-label fw-bolder fs-3 mb-1 text-light\">Ethnic Group</span></div></div><div class=\"card-toolbar\"></div></div>", 1)
const _hoisted_3 = { class: "card mb-5 mb-xl-10 m-6" }
const _hoisted_4 = {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_5 = { class: "row mt-1 w-100 m-0" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "div pb-2" }
const _hoisted_8 = {
  class: "col-md-6 mt-1 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_10 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_11 = { class: "collapse show" }
const _hoisted_12 = { class: "card-body border-top p-6" }
const _hoisted_13 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-eye" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-pencil-alt" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-trash-alt" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  class: "modal fade",
  id: "ethnic_details",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_24 = { class: "modal-dialog mw-650px" }
const _hoisted_25 = { class: "modal-content" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  class: "modal-header bg-primary",
  id: "kt_modal_add_ethnic_header"
}, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-light" }, "Add Ethnic Group"),
  /*#__PURE__*/_createElementVNode("div", {
    id: "kt_modal_add_ethnic_close",
    "data-bs-dismiss": "modal",
    class: "btn btn-icon btn-sm btn-active-icon-primary"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times text-light" })
  ])
], -1)
const _hoisted_27 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_28 = { class: "table-responsive mt-5" }
const _hoisted_29 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-0" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Code"),
    /*#__PURE__*/_createElementVNode("th", null, "Ethnic Group")
  ])
], -1)
const _hoisted_31 = { class: "fw-bold" }
const _hoisted_32 = { class: "fw-bold" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-danger",
    "data-bs-dismiss": "modal"
  }, " Close ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_EthnicGroupModal = _resolveComponent("EthnicGroupModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control ps-10 w-200px mt-1 form-control-sm",
                  style: {"height":"1em"},
                  placeholder: "Search",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                  onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems()))
                }, null, 544), [
                  [_vModelText, _ctx.search]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args))),
                type: "button",
                class: "btn btn-primary btn-sm mb-1",
                "data-bs-toggle": "modal",
                "data-bs-target": "#kt_modal_add_industry"
              }, [
                _hoisted_9,
                _createTextVNode(" Add Ethnic Group ")
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_Datatable, {
                  "table-data": _ctx.tableData,
                  "table-header": _ctx.tableHeader,
                  "enable-items-per-page-dropdown": true
                }, {
                  "cell-sl": _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.id), 1)
                  ]),
                  "cell-code": _withCtx(({ row: ethnic }) => [
                    _createTextVNode(_toDisplayString(ethnic.code), 1)
                  ]),
                  "cell-ethnic_group": _withCtx(({ row: ethnic }) => [
                    _createTextVNode(_toDisplayString(ethnic.ethnic_group), 1)
                  ]),
                  "cell-actions": _withCtx(({ row: ethnic }) => [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.view(ethnic)),
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#ethnic_details",
                      class: "btn btn-icon btn-info btn-sm me-1"
                    }, _hoisted_16, 8, _hoisted_14),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.edit(ethnic)),
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#kt_modal_add_ethnic",
                      class: "btn btn-icon btn-primary btn-sm me-1"
                    }, _hoisted_19, 8, _hoisted_17),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.Delete(ethnic.id)),
                      class: "btn btn-icon btn-danger btn-sm"
                    }, _hoisted_22, 8, _hoisted_20)
                  ]),
                  _: 1
                }, 8, ["table-data", "table-header"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("table", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.data.code), 1),
                    _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.data.ethnic_group), 1)
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_33
        ])
      ])
    ]),
    _createVNode(_component_EthnicGroupModal)
  ], 64))
}